(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('LayoutTemplateComponentModalController', LayoutTemplateComponentModalController);

    LayoutTemplateComponentModalController.$inject = [
        '$uibModalInstance',
        'modalData',
        '$translate',
        '$localStorage',
        '$timeout',
        '$q',
        'SHOWCASE_LAYOUT_TEMPLATE_CONSTANTS',
        'FlyerCategoryService',
        'BrandService',
        'ShowcaseLayoutTemplateService',
        'FlyersService',
        'toastr',
        'paginationConstants'
    ];

    function LayoutTemplateComponentModalController(
        $uibModalInstance,
        modalData,
        $translate,
        $localStorage,
        $timeout,
        $q,
        SHOWCASE_LAYOUT_TEMPLATE_CONSTANTS,
        FlyerCategoryService,
        BrandService,
        ShowcaseLayoutTemplateService,
        FlyersService,
        toastr,
        paginationConstants
    ) {
        var vm = this;
        var KEYS = SHOWCASE_LAYOUT_TEMPLATE_CONSTANTS.COMPONENT_KEYS;
        var BANNER_LINK_MAX_SIZE = 1000;
        var BANNER_NAME_MAX_SIZE = 255;
        var bannerSearchTimeout = null;

        vm.block = modalData.block;
        vm.rowNumber = modalData.rowNumber;
        vm.columnNumber = modalData.columnNumber;
        vm.isEditing = !!modalData.editingComponent;
        vm.step = 'pick';
        vm.selectedOption = null;
        vm.componentTitle = '';
        vm.productFilters = {
            gender: null,
            highlights: [],
            categoryKeys: [],
            brands: []
        };
        vm.isImmoContext = $localStorage.defaultStore && $localStorage.defaultStore.immoContext;
        vm.showGenderFilter = $localStorage.defaultStore &&
            $localStorage.defaultStore.category === 'FASHION' &&
            !vm.isImmoContext;
        vm.genderOptions = buildGenderOptions();
        vm.categories = [];
        vm.brands = [];
        vm.highlightOptions = [
            { id: 'isLaunch', label: 'flyers.new.form.configurations.launch', value: 'isLaunch' },
            { id: 'isBasic', label: 'flyers.new.form.configurations.basic', value: 'isBasic' }
        ];

        vm.banners = [];
        vm.selectedBanners = [];
        vm.bannerSearchQuery = '';
        vm.selectedBannerIds = [];
        vm.isLoadingBanners = false;
        vm.isLoadingSelectedBanners = false;
        vm.bannersLoadError = false;
        vm.bannerPage = 0;
        vm.bannerCurrentPage = 1;
        vm.bannerNumPerPage = paginationConstants.itemsPerPageSmall;
        vm.bannerTotalItems = 0;
        vm.bannerStartRegistry = 0;
        vm.bannerEndRegistry = 0;
        vm.bannerPaginationMaxSize = 5;
        vm.showUploadPanel = false;
        vm.isSavingBanner = false;
        vm.uploadForm = emptyUploadForm();

        vm.availableOptions = buildAvailableOptions();
        vm.filteredOptions = [];
        vm.searchQuery = '';
        vm.activeGroup = 'all';
        vm.groupFilters = [
            { id: 'all', labelKey: 'showcase-layout-template.modal.groups.all' },
            { id: 'products', labelKey: 'showcase-layout-template.modal.groups.products' },
            { id: 'brands', labelKey: 'showcase-layout-template.modal.groups.brands' },
            { id: 'banners', labelKey: 'showcase-layout-template.modal.groups.banners' }
        ];
        vm.close = close;
        vm.selectOption = selectOption;
        vm.goToFilters = goToFilters;
        vm.goBackToPick = goBackToPick;
        vm.confirm = confirm;
        vm.canConfirm = canConfirm;
        vm.isProductOption = isProductOption;
        vm.isBannerOption = isBannerOption;
        vm.getAreaLabel = getAreaLabel;
        vm.applyFilters = applyFilters;
        vm.setActiveGroup = setActiveGroup;
        vm.toggleBannerSelection = toggleBannerSelection;
        vm.isBannerSelected = isBannerSelected;
        vm.getSelectedBannerCount = getSelectedBannerCount;
        vm.getBannerDisplayName = getBannerDisplayName;
        vm.removeSelectedBanner = removeSelectedBanner;
        vm.changeBannerPage = changeBannerPage;
        vm.onBannerSearchChange = onBannerSearchChange;
        vm.toggleUploadPanel = toggleUploadPanel;
        vm.cancelUpload = cancelUpload;
        vm.onWebFileSelected = onWebFileSelected;
        vm.onMobileFileSelected = onMobileFileSelected;
        vm.clearWebPreview = clearWebPreview;
        vm.clearMobilePreview = clearMobilePreview;
        vm.saveNewBanner = saveNewBanner;
        vm.getConfirmLabelKey = getConfirmLabelKey;

        init();

        function init() {
            filterOptionsByCatalog();
            applyFilters();

            if (vm.isEditing) {
                initEditingComponent(modalData.editingComponent);
            }

            $q.all([loadCategories(), loadBrands()]).then(function () {
                if (vm.isEditing && isProductOption(vm.selectedOption)) {
                    hydrateProductFilters(modalData.editingComponent && modalData.editingComponent.parsedValue);
                }
            });
        }

        function initEditingComponent(component) {
            vm.selectedOption = vm.availableOptions.find(function (option) {
                return option.componentKey === component.componentKey;
            });

            if (!vm.selectedOption) {
                return;
            }

            vm.componentTitle = component.title || $translate.instant(vm.selectedOption.labelKey);

            if (isBannerOption(vm.selectedOption)) {
                vm.step = 'banner';
                vm.selectedBannerIds = (component.parsedValue && component.parsedValue.bannerIds)
                    ? component.parsedValue.bannerIds.map(normalizeBannerId)
                    : [];
                vm.selectedBanners = [];
                loadSelectedBanners();
                resetBannerPage();
                loadBanners();
                return;
            }

            vm.step = 'filters';
        }

        function hydrateProductFilters(parsedValue) {
            if (!parsedValue) {
                return;
            }

            var highlights = [];
            if (parsedValue.isLaunch) {
                highlights.push(findHighlightOption('isLaunch'));
            }
            if (parsedValue.isBasic) {
                highlights.push(findHighlightOption('isBasic'));
            }
            vm.productFilters.highlights = highlights.filter(Boolean);

            vm.productFilters.categoryKeys = (parsedValue.categoryKeys || []).map(function (key) {
                return vm.categories.find(function (category) {
                    return category.value === key || category.id === key;
                });
            }).filter(Boolean);

            vm.productFilters.brands = (parsedValue.brands || []).map(function (brandName) {
                return vm.brands.find(function (brand) {
                    return brand.value === brandName || brand.name === brandName || brand.label === brandName;
                });
            }).filter(Boolean);

            if (parsedValue.gender !== null && parsedValue.gender !== undefined && parsedValue.gender !== '') {
                vm.productFilters.gender = String(parsedValue.gender);
            }
        }

        function findHighlightOption(value) {
            return vm.highlightOptions.find(function (option) {
                return option.value === value;
            });
        }

        function emptyUploadForm() {
            return {
                name: '',
                link: '',
                webPreview: null,
                mobilePreview: null,
                webDataUrl: null,
                mobileDataUrl: null
            };
        }

        function loadCategories() {
            return FlyerCategoryService.listCategoriesByCurrentStore().then(function (response) {
                var categories = response.data || response || [];
                vm.categories = categories.map(function (category) {
                    return {
                        id: category.id || category.key,
                        value: category.key,
                        label: category.title || category.key,
                        name: category.title || category.key
                    };
                });
            }, function () {
                vm.categories = [];
            });
        }

        function loadBrands() {
            return BrandService.getBrandsByCurrentStore().then(function (response) {
                var brands = response.data || response || [];
                vm.brands = brands.map(function (brand) {
                    return {
                        id: brand.id,
                        value: brand.name,
                        label: brand.name,
                        name: brand.name
                    };
                });
            }, function () {
                vm.brands = [];
            });
        }

        function loadBanners() {
            vm.isLoadingBanners = true;
            vm.bannersLoadError = false;

            ShowcaseLayoutTemplateService.listStoreBanners({
                page: vm.bannerPage,
                size: vm.bannerNumPerPage,
                sort: 'id,desc'
            }, vm.bannerSearchQuery).then(function (response) {
                var headers = response.headers;
                vm.banners = response.data || [];
                vm.bannerTotalItems = parseInt(headers('X-Total-Count'), 10) || vm.banners.length;
                vm.bannerStartRegistry = vm.bannerTotalItems === 0 ? 0 : (vm.bannerPage * vm.bannerNumPerPage) + 1;
                vm.bannerEndRegistry = Math.min((vm.bannerPage + 1) * vm.bannerNumPerPage, vm.bannerTotalItems);
                vm.isLoadingBanners = false;
            }, function () {
                vm.isLoadingBanners = false;
                vm.bannersLoadError = true;
                vm.banners = [];
                vm.bannerTotalItems = 0;
                vm.bannerStartRegistry = 0;
                vm.bannerEndRegistry = 0;
                toastr.error($translate.instant('showcase-layout-template.modal.banner.loadError'));
            });
        }

        function loadSelectedBanners() {
            if (!vm.selectedBannerIds.length) {
                vm.selectedBanners = [];
                return;
            }

            vm.isLoadingSelectedBanners = true;
            ShowcaseLayoutTemplateService.listStoreBannersByIds(vm.selectedBannerIds).then(function (banners) {
                vm.selectedBanners = banners || [];
                vm.isLoadingSelectedBanners = false;
            }, function () {
                vm.selectedBanners = [];
                vm.isLoadingSelectedBanners = false;
            });
        }

        function resetBannerPage() {
            vm.bannerPage = 0;
            vm.bannerCurrentPage = 1;
        }

        function changeBannerPage() {
            vm.bannerPage = vm.bannerCurrentPage - 1;
            loadBanners();
        }

        function onBannerSearchChange() {
            if (bannerSearchTimeout) {
                $timeout.cancel(bannerSearchTimeout);
            }
            bannerSearchTimeout = $timeout(function () {
                resetBannerPage();
                loadBanners();
            }, 300);
        }

        function filterOptionsByCatalog() {
            vm.availableOptions = vm.availableOptions.filter(function (option) {
                return !!findCatalogItem(option);
            });
        }

        function setActiveGroup(groupId) {
            vm.activeGroup = groupId;
            applyFilters();
        }

        function applyFilters() {
            var query = (vm.searchQuery || '').toLowerCase().trim();

            vm.filteredOptions = vm.availableOptions.filter(function (option) {
                if (vm.activeGroup !== 'all' && option.group !== vm.activeGroup) {
                    return false;
                }
                if (!query) {
                    return true;
                }
                var title = $translate.instant(option.labelKey).toLowerCase();
                var description = $translate.instant(option.descriptionKey).toLowerCase();
                return title.indexOf(query) !== -1 || description.indexOf(query) !== -1;
            });
        }

        function getBannerDisplayName(banner) {
            if (!banner) {
                return '';
            }
            if (banner.name && banner.name.trim()) {
                return banner.name.trim();
            }
            return $translate.instant('showcase-layout-template.modal.banner.unnamed');
        }

        function toggleBannerSelection(banner, $event) {
            if ($event) {
                $event.stopPropagation();
            }

            var bannerId = normalizeBannerId(banner.id);
            var index = vm.selectedBannerIds.indexOf(bannerId);

            if (index === -1) {
                vm.selectedBannerIds.push(bannerId);
                vm.selectedBanners.push(banner);
            } else {
                vm.selectedBannerIds.splice(index, 1);
                removeSelectedBannerById(bannerId);
            }
        }

        function removeSelectedBanner(banner, $event) {
            if ($event) {
                $event.stopPropagation();
                $event.preventDefault();
            }

            var bannerId = normalizeBannerId(banner.id);
            var index = vm.selectedBannerIds.indexOf(bannerId);
            if (index !== -1) {
                vm.selectedBannerIds.splice(index, 1);
            }
            removeSelectedBannerById(bannerId);
        }

        function removeSelectedBannerById(bannerId) {
            vm.selectedBanners = vm.selectedBanners.filter(function (banner) {
                return normalizeBannerId(banner.id) !== bannerId;
            });
        }

        function isBannerSelected(banner) {
            return vm.selectedBannerIds.indexOf(normalizeBannerId(banner.id)) !== -1;
        }

        function getSelectedBannerCount() {
            return vm.selectedBannerIds.length;
        }

        function normalizeBannerId(id) {
            return parseInt(id, 10);
        }

        function toggleUploadPanel() {
            vm.showUploadPanel = !vm.showUploadPanel;
            if (!vm.showUploadPanel) {
                cancelUpload();
            }
        }

        function cancelUpload() {
            vm.showUploadPanel = false;
            vm.uploadForm = emptyUploadForm();
        }

        function onWebFileSelected(file) {
            processBannerFile('web', file);
        }

        function onMobileFileSelected(file) {
            processBannerFile('mobile', file);
        }

        function clearWebPreview($event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            vm.uploadForm.webPreview = null;
            vm.uploadForm.webDataUrl = null;
        }

        function clearMobilePreview($event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            vm.uploadForm.mobilePreview = null;
            vm.uploadForm.mobileDataUrl = null;
        }

        function processBannerFile(imageType, file) {
            if (!file) {
                return;
            }

            if (!isAllowedImageType(file.type)) {
                toastr.error($translate.instant('showcase-layout-template.modal.banner.uploadInvalidType'));
                return;
            }

            var reader = new FileReader();
            reader.onload = function (loadEvent) {
                var img = document.createElement('img');
                img.onload = function () {
                    $timeout(function () {
                        var dataUrl;
                        if (imageType === 'mobile') {
                            var canvas = document.createElement('canvas');
                            canvas.width = 650;
                            canvas.height = 640;
                            var ctx = canvas.getContext('2d');
                            ctx.drawImage(img, 0, 0, 650, 640);
                            dataUrl = canvas.toDataURL(file.type || 'image/jpeg');
                            vm.uploadForm.mobilePreview = dataUrl;
                            vm.uploadForm.mobileDataUrl = dataUrl;
                        } else {
                            dataUrl = loadEvent.target.result;
                            vm.uploadForm.webPreview = dataUrl;
                            vm.uploadForm.webDataUrl = dataUrl;
                        }
                    });
                };
                img.onerror = function () {
                    toastr.error($translate.instant('showcase-layout-template.modal.banner.uploadInvalidType'));
                };
                img.src = loadEvent.target.result;
            };
            reader.onerror = function () {
                toastr.error($translate.instant('showcase-layout-template.modal.banner.uploadError'));
            };
            reader.readAsDataURL(file);
        }

        function isAllowedImageType(mimeType) {
            return mimeType === 'image/jpeg' || mimeType === 'image/jpg' || mimeType === 'image/png';
        }

        function saveNewBanner($event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }

            if (vm.isSavingBanner) {
                return;
            }

            var name = (vm.uploadForm.name || '').trim();
            if (!name) {
                toastr.warning($translate.instant('showcase-layout-template.modal.banner.uploadNameRequired'));
                return;
            }
            if (name.length > BANNER_NAME_MAX_SIZE) {
                toastr.error($translate.instant('showcase-layout-template.modal.banner.uploadNameTooLong'));
                return;
            }
            if (!vm.uploadForm.webDataUrl) {
                toastr.warning($translate.instant('showcase-layout-template.modal.banner.uploadWebRequired'));
                return;
            }
            if (vm.uploadForm.link && vm.uploadForm.link.length > BANNER_LINK_MAX_SIZE) {
                toastr.error($translate.instant('showcases.detail.banner.error.bannerLinkExceedingSizeLimit'));
                return;
            }

            vm.isSavingBanner = true;
            var webBlob = dataURItoBlob(vm.uploadForm.webDataUrl);

            FlyersService.saveFlyerMultiImage(webBlob, 0).then(function (webResponse) {
                var coverImage = webResponse && (webResponse.data || webResponse);
                if (!coverImage || !coverImage.uuid) {
                    return $q.reject();
                }

                var mobilePromise;

                if (vm.uploadForm.mobileDataUrl) {
                    var mobileBlob = dataURItoBlob(vm.uploadForm.mobileDataUrl);
                    mobilePromise = FlyersService.saveFlyerMultiImage(mobileBlob, 1).then(function (mobileResponse) {
                        return mobileResponse && (mobileResponse.data || mobileResponse);
                    });
                } else {
                    mobilePromise = $q.when(null);
                }

                return mobilePromise.then(function (mobileImage) {
                    var payload = {
                        name: name,
                        link: (vm.uploadForm.link || '').trim() || null,
                        coverImage: {
                            uuid: coverImage.uuid,
                            extensionFile: coverImage.extensionFile
                        }
                    };

                    if (mobileImage) {
                        payload.mobileImage = {
                            uuid: mobileImage.uuid,
                            extensionFile: mobileImage.extensionFile
                        };
                    }

                    return ShowcaseLayoutTemplateService.createStoreBanner(payload);
                });
            }).then(function (createdBanner) {
                resetBannerPage();
                loadBanners();

                var newId = normalizeBannerId(createdBanner.id);
                if (vm.selectedBannerIds.indexOf(newId) === -1) {
                    vm.selectedBannerIds.unshift(newId);
                    vm.selectedBanners.unshift(createdBanner);
                }

                cancelUpload();
                vm.isSavingBanner = false;
                toastr.success($translate.instant('showcase-layout-template.modal.banner.uploadSuccess'));
            }, function () {
                vm.isSavingBanner = false;
                toastr.error($translate.instant('showcase-layout-template.modal.banner.uploadError'));
            });
        }

        function dataURItoBlob(dataURI) {
            var byteString;
            if (dataURI.split(',')[0].indexOf('base64') >= 0) {
                byteString = atob(dataURI.split(',')[1]);
            } else {
                byteString = unescape(dataURI.split(',')[1]);
            }
            var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
            var ia = new Uint8Array(byteString.length);
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }
            return new Blob([ia], { type: mimeString });
        }

        function buildAvailableOptions() {
            return [
                {
                    id: 'products-carousel',
                    group: 'products',
                    iconClass: 'icon-ksc-bag-light',
                    componentKey: KEYS.PRODUCTS_HORIZONTAL,
                    labelKey: 'showcase-layout-template.components.products.list',
                    descriptionKey: 'showcase-layout-template.components.products.listDesc',
                    tagKeys: ['showcase-layout-template.components.tags.carousel']
                },
                {
                    id: 'brands-carousel',
                    group: 'brands',
                    iconClass: 'icon-ksc-tag-light',
                    componentKey: KEYS.BRANDS_HORIZONTAL,
                    labelKey: 'showcase-layout-template.components.brands.list',
                    descriptionKey: 'showcase-layout-template.components.brands.listDesc',
                    tagKeys: ['showcase-layout-template.components.tags.carousel']
                },
                {
                    id: 'banner-carousel',
                    group: 'banners',
                    iconClass: 'icon-ksc-image-light-1',
                    componentKey: KEYS.BANNER_CAROUSEL,
                    labelKey: 'showcase-layout-template.components.banners.carousel',
                    descriptionKey: 'showcase-layout-template.components.banners.carouselDesc',
                    tagKeys: ['showcase-layout-template.components.tags.carousel']
                }
            ];
        }

        function selectOption(option) {
            vm.selectedOption = option;
            vm.componentTitle = $translate.instant(option.labelKey);

            if (isBannerOption(option)) {
                vm.step = 'banner';
                vm.bannerSearchQuery = '';
                vm.selectedBannerIds = [];
                vm.selectedBanners = [];
                vm.showUploadPanel = false;
                vm.uploadForm = emptyUploadForm();
                resetBannerPage();
                loadBanners();
                return;
            }

            vm.step = 'filters';
        }

        function goToFilters() {
            if (!vm.selectedOption) {
                return;
            }
            vm.step = isBannerOption(vm.selectedOption) ? 'banner' : 'filters';
        }

        function goBackToPick() {
            if (vm.isEditing) {
                close();
                return;
            }
            vm.step = 'pick';
        }

        function isProductOption(option) {
            return option && option.componentKey && option.componentKey.indexOf('PRODUCTS_') === 0;
        }

        function isBannerOption(option) {
            return option && option.componentKey === KEYS.BANNER_CAROUSEL;
        }

        function requiresValueConfiguration(option) {
            var catalogItem = findCatalogItem(option);
            return !!(catalogItem && catalogItem.hasValue);
        }

        function findCatalogItem(option) {
            if (!option) {
                return null;
            }
            return (modalData.viewComponentCatalog || []).find(function (item) {
                return item.key === option.componentKey;
            });
        }

        function canConfirm() {
            if (!vm.selectedOption) {
                return false;
            }

            if (isBannerOption(vm.selectedOption)) {
                return vm.selectedBannerIds.length > 0 && !vm.isSavingBanner;
            }

            return true;
        }

        function getConfirmLabelKey() {
            return vm.isEditing ? 'entity.action.save' : 'showcase-layout-template.buttons.insert';
        }

        function confirm() {
            if (!vm.selectedOption || !canConfirm()) {
                return;
            }

            var catalogItem = findCatalogItem(vm.selectedOption);

            if (!catalogItem) {
                return;
            }

            var parsedValue = null;

            if (isBannerOption(vm.selectedOption)) {
                parsedValue = buildBannerValue();
            } else if (requiresValueConfiguration(vm.selectedOption)) {
                parsedValue = buildProductFilterValue();
            }

            var component = {
                title: vm.componentTitle || $translate.instant(vm.selectedOption.labelKey),
                viewComponentId: catalogItem.id,
                componentKey: vm.selectedOption.componentKey,
                parsedValue: parsedValue
            };

            if (isBannerOption(vm.selectedOption)) {
                component.previewBanners = vm.selectedBanners.slice();
            }

            if (vm.isEditing && modalData.editingComponent) {
                component.id = modalData.editingComponent.id;
            }

            $uibModalInstance.close(component);
        }

        function buildBannerValue() {
            return {
                bannerIds: vm.selectedBannerIds.slice()
            };
        }

        function buildProductFilterValue() {
            var value = {};

            (vm.productFilters.highlights || []).forEach(function (highlight) {
                var highlightValue = highlight.value || highlight;
                if (highlightValue === 'isLaunch') {
                    value.isLaunch = true;
                }
                if (highlightValue === 'isBasic') {
                    value.isBasic = true;
                }
            });

            if (vm.productFilters.categoryKeys && vm.productFilters.categoryKeys.length) {
                value.categoryKeys = vm.productFilters.categoryKeys.map(function (item) {
                    return item.value || item;
                });
            }

            if (vm.productFilters.brands && vm.productFilters.brands.length) {
                value.brands = vm.productFilters.brands.map(function (item) {
                    return item.value || item.name || item.label;
                });
            }

            if (vm.productFilters.gender !== null && vm.productFilters.gender !== undefined &&
                vm.productFilters.gender !== '') {
                value.gender = parseInt(vm.productFilters.gender, 10);
            }

            return value;
        }

        function buildGenderOptions() {
            return [
                { id: '1', title: $translate.instant('flyers.new.form.gender.male') },
                { id: '2', title: $translate.instant('flyers.new.form.gender.female') },
                { id: '3', title: $translate.instant('flyers.new.form.gender.both') }
            ];
        }

        function getAreaLabel() {
            return $translate.instant('showcase-layout-template.modal.selectedSlot', {
                row: vm.rowNumber || 1,
                column: vm.columnNumber || 1
            });
        }

        function close() {
            $uibModalInstance.dismiss('cancel');
        }
    }

})();
